// The classes the marketing and legal pages share. A page is a stack of plain
// bands, each with its content in a column as wide as the header's.
export const band =
  'border-t border-line px-8 py-20 first:border-t-0 max-md:px-4 max-md:py-12';
export const inner = 'mx-auto max-w-page';
export const split =
  'grid items-center gap-x-16 gap-y-10 lg:grid-cols-2 [&>*]:min-w-0';

export const pageTitle =
  'font-display text-[clamp(2rem,4vw,3rem)] leading-[1.1] font-semibold tracking-[-0.015em] text-balance text-ink';
export const sectionTitle =
  'p-0 font-display text-[1.875rem] leading-[1.2] font-semibold tracking-[-0.01em] text-balance text-ink max-md:text-2xl';
export const cardTitle =
  'text-xl leading-snug font-semibold tracking-tight text-ink';
export const prose =
  'max-w-xl text-17 leading-[1.6] text-ink-2 [&_p:last-child]:mb-0';
export const textLink =
  'inline-flex min-h-11 items-center gap-1 text-15 font-semibold text-accent-text';

// The illustrations were drawn for a white page. The frame keeps them on one,
// whatever the theme.
export const frame = 'overflow-hidden rounded-2xl border border-line bg-white';
export const picture = 'block h-auto w-full max-w-full';

// Terms and privacy: one column, sized for reading.
export const article =
  'mx-auto max-w-[46rem] px-4 py-16 text-17 leading-[1.6] wrap-break-word text-ink-2 max-md:py-10 [&_strong]:font-semibold [&_strong]:text-ink';
export const articleTitle =
  'font-display text-[clamp(2rem,4vw,3rem)] leading-[1.1] font-semibold tracking-[-0.015em] text-ink';
export const articleDate = 'mt-3 text-15 text-ink-muted';
export const articleHeading =
  'mt-10 mb-3 p-0 text-xl leading-snug font-semibold tracking-tight text-ink';
